import { render, staticRenderFns } from "./AddBroker.vue?vue&type=template&id=1ce983a5&"
import script from "./AddBroker.vue?vue&type=script&lang=ts&"
export * from "./AddBroker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports